import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import StoryList from './StoryList';
import StoryView from './StoryView';
import { actions as runningOrderActions } from '../../actions/runningOrder';
import LuciPropTypes from '../../propTypes/';
import ControlBar from './ControlBar';
import { Container, MainContent, StickyHeader } from '../../styled-components/Layout';

const RunningOrdersContainer = styled(Container)`
  display: flex;
  flex-direction: row;
  height: 100%;
`;

const StoryListContainer = styled(Container)`
  flex-basis: 15rem;
  flex-grow: 0;
  flex-shrink: 0;
  overflow-y: scroll;
`;

const StoryContainer = styled(Container)`
  padding-left: 0.25rem;
  width: 100%;
  margin-top: 0.25rem;
  flex-direction: column;
`;

class RunningOrders extends Component {
  UNSAFE_componentWillMount() {
    const { selectedRunningOrderId, getRunningOrder, getRunningOrdersList } = this.props;
    getRunningOrdersList();
    if (selectedRunningOrderId) {
      getRunningOrder(selectedRunningOrderId);
    }
  }
  render() {
    const { storyList, selectedStoryId, selectStory } = this.props;
    const selectedStory = storyList.find(story => story.id === selectedStoryId);
    return (
      <RunningOrdersContainer id="runningOrderContainer">
        <StoryListContainer>
          <StoryList
            storyList={storyList}
            selectedStoryId={selectedStoryId}
            selectStory={selectStory}
            openEditor={this.props.openEditor}
          />
        </StoryListContainer>
        <StoryContainer>
          <StickyHeader>
            <ControlBar />
          </StickyHeader>
          <MainContent>
            <StoryView story={selectedStory} openEditor={this.props.openEditor} />
          </MainContent>
        </StoryContainer>
      </RunningOrdersContainer>
    );
  }
}

RunningOrders.defaultProps = {
  selectedRunningOrderId: null,
  storyList: [],
  openEditor: () => {}
};

RunningOrders.propTypes = {
  storyList: PropTypes.arrayOf(LuciPropTypes.Story),
  getRunningOrder: PropTypes.func.isRequired,
  getRunningOrdersList: PropTypes.func.isRequired,
  selectedRunningOrderId: PropTypes.string,
  selectedStoryId: PropTypes.string.isRequired,
  selectStory: PropTypes.func.isRequired,
  openEditor: PropTypes.func
};

const mapStateToProps = state => ({
  storyList: state.runningOrder.runningOrder.stories,
  selectedRunningOrderId: state.runningOrder.runningOrder.id,
  selectedStoryId: state.runningOrder.selectedStoryId
});

const mapActionCreators = {
  getRunningOrder: runningOrderActions.getRunningOrder,
  getRunningOrdersList: runningOrderActions.getRunningOrdersList,
  selectStory: runningOrderActions.selectStory
};

export default connect(
  mapStateToProps,
  mapActionCreators
)(RunningOrders);



// WEBPACK FOOTER //
// ./app/components/RunningOrders/RunningOrders.js